<nav [ngClass]="isOpenSubMenu?.id ? 'close-main' : 'open-main'">
  <p class="menu-title open">{{ 'COMUN.MENU' | translate }}</p>
  <ul>
    @for (item of rawSidebarItems; track item) {
    <li (click)="handlerClick(item)" class="menu-item" tabindex="0" (keydown.enter)="handlerClick(item)"
      routerLinkActive="active" [routerLink]="item.url">
      <!-- QUE EL LABEL QUE VIENE DEL SP SE AJUSTE AL TRANSLATE --->
      <a>{{ "NAV_SIDEBAR." + item.traduccion | translate }}
        @if (item.subLabel) {
        <i class="bi bi-chevron-compact-right"></i>
        }
      </a>
    </li>
    }
  </ul>



</nav>

<nav [ngClass]="isOpenSubMenu?.id ? 'open' : 'close'" class="submenu">
  <span (click)="closeSubMenu()" class="menu-title" tabindex="0" (keydown.enter)="closeSubMenu()">
    <i class="bi bi-chevron-compact-left"></i>
    <p>{{ "NAV_SIDEBAR." + isOpenSubMenu?.traduccion || '‎' | translate }}</p>
  </span>
  <ul>
    @for (item of isOpenSubMenu?.subLabel; track item.id) {
    <li tabindex="0" (keydown.enter)="handlerClick(item)" (click)="handlerClick(item)" class="menu-item"
      routerLinkActive="active" [routerLink]="item.url">
      <a>{{ "NAV_SIDEBAR." + item.traduccion | translate}}</a>
    </li>
    }
  </ul>

</nav>